import React from "react";

const NotFoundView = () => (
  <div
    style={{
      background: "#0d68ac",
      width: "100%",
      minHeight: "calc(100vh - 250px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div className="bootstrap3-layout" style={{ width: "100%" }}>
      <div className="container">
        <h3
          className="header1-notFound text-center"
          style={{
            color: "#f5f5f5",
            fontSize: "24px",
            margin: 0,
            textAlign: "center",
          }}
        >
          Sorry we can't find that page.
        </h3>
      </div>
    </div>
  </div>
);

export default NotFoundView;